import * as React from "react";

/**
 * idle: 비어 있음 — 아무 표시도 하지 않는다.
 * valid: 이메일 형식이 맞음(완료 표시).
 * invalid: 값은 있지만 이메일 형식이 아님(X 표시).
 */
export type EmailFormatStatus = "idle" | "valid" | "invalid";

/** 기본적인 이메일 형식 검사: `공백/@ 없는 로컬` @ `공백/@ 없는 도메인` `.` `TLD`. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** 입력값이 이메일 형식인지 실시간으로 판정한다. 서버 확인(중복 여부 등)은 하지 않는다. */
export function useEmailFormatStatus(value: string): EmailFormatStatus {
  return React.useMemo(() => {
    if (value === "") return "idle";
    return EMAIL_PATTERN.test(value) ? "valid" : "invalid";
  }, [value]);
}
